/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface FinancialSupportRunwayControllerAnalyze$Params {
  id: string;
  'X-Financial-Support-Token': string;
}

export function financialSupportRunwayControllerAnalyze(http: HttpClient, rootUrl: string, params: FinancialSupportRunwayControllerAnalyze$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, financialSupportRunwayControllerAnalyze.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Financial-Support-Token', params['X-Financial-Support-Token'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

financialSupportRunwayControllerAnalyze.PATH = '/api/financial-support/cases/{id}/runway-analysis';
